module.exports = __webpack_public_path__ + "img/face-shush.d9450b36.svg";